<template>
  <span>
    <style-dialog-style-row
      v-for="item of items"
      v-bind="{ ...item, hasCopyButton, styleType, stylePropsList }"
      :key="item.name"
      v-model="value[item.name]"
    >
      <template v-for="(value, key) in $scopedSlots" #[key]="scope">
        <slot :name="key" v-bind="{ ...scope, ...$props.items.find(item => item.name === key) }" />
      </template>
    </style-dialog-style-row>
  </span>
</template>
<script>
import StyleDialogStyleRow from '@/components/StyleDialogStyleRow';
export default {
  name: 'StyleDialogStyleRows',
  components: {
    StyleDialogStyleRow,
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: Object,
      required: true,
    },
    hasCopyButton: {
      type: Boolean,
      default: false,
    },
    styleType: {
      type: String,
      validator: v => {
        return ['style', 'label'].includes(v);
      },
    },
  },
  computed: {
    stylePropsList() {
      return this.items.map(item => item.name);
    },
  },
};
</script>
